import { Fragment } from "react";

import { AisSitesType } from "@/libraries/bxp-web-stargate-client/src/index";
import { TypographyStyles } from "@/libraries/wpl/foundations/src";

import ExploreMoreSection from "./explore-more-section";
import LogMeInSection from "./log-me-in";

interface HeroSectionProps {
    confluenceSites: AisSitesType[];
    userProfileName: string | undefined;
    hideExploreMore?: boolean;
    loggedInPaid?: boolean;
}

export const HeroSection = ({ ...props }: HeroSectionProps) => {
    return (
        <Fragment>
            {props.loggedInPaid ? (
                <TypographyStyles>
                    <LogMeInSection {...props} />
                </TypographyStyles>
            ) : (
                <LogMeInSection {...props} />
            )}
            {!props.hideExploreMore && <ExploreMoreSection />}
        </Fragment>
    );
};

export default HeroSection;
